export const multiSelectValueAdapter = (values: string[], target: 'frontend' | 'backend'): string[] => {
  if (!Array.isArray(values)) return [];

  if (target === 'frontend') {
    return values.map(v => (v === '汇总' ? '255' : v));
  }

  if (target === 'backend') {
    return values.map(v => (v === '255' ? '汇总' : v));
  }
};
